import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8 md:mb-10">
          频道导航
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href={item.href}
              className="group bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200/50 hover:bg-background-50 transition-all duration-300 text-center cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 rounded-2xl bg-secondary-100 flex items-center justify-center group-hover:bg-primary-50 transition-colors duration-300">
                <i className={`${item.icon} text-secondary-500 group-hover:text-primary-500 text-xl md:text-2xl transition-colors duration-300`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-1 whitespace-nowrap">{item.title}</h3>
              <p className="text-xs text-foreground-500">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}